__webpack_require__.p = "/mi-assets/mi-static/mi-groups-renderer/web-rel-26.2.1-02072026/_next/";